import React from "react";
import { renderBatteryCompact } from "./mySystemsFormRenderers/battery";
import { renderLamperSixLines } from "./mySystemsFormRenderers/lamps";
import { renderValueSafeInline } from "./mySystemsFormRenderers/valueFormat";
import { StatusIcon } from "./mySystemsFormRenderers/statusIcon";
import {
  formatNorwegianShort,
  isOlderThanTwoHours,
} from "./mySystemsFormRenderers/dateFormat";

export default function ClusterSystemsCard({ cluster }) {
  const showBattery =
    Array.isArray(cluster.systems) &&
    cluster.systems.some((s) => {
      const b = s?.batteri ?? s?.battery ?? s?.batt ?? null;
      return (
        b != null &&
        ((Array.isArray(b) && b.length > 0) ||
          (typeof b === "object" && Object.keys(b).length > 0))
      );
    });

  return (
    <div className="viewcard21">
      <h2 style={{ marginBottom: 4 }}>{cluster.nick}</h2>
      <h5 style={{ marginTop: 0, marginBottom: 8 }}>{cluster.name}</h5>

      {Array.isArray(cluster.systems) && cluster.systems.length > 0 ? (
        <table className="systems-table" style={{ tableLayout: "fixed" }}>
          <colgroup>
            <col className="status-col" />
            <col className="system-col" />
            <col className="lamper-col" />
            <col className="ctrl-col" />
            {showBattery ? <col className="battery-col" /> : null}
          </colgroup>

          <thead>
            <tr>
              <th>Status</th>
              <th>Merde</th>
              <th>Lamper</th>
              <th>Kontrollboks</th>
              {showBattery ? <th>Batteri</th> : null}
            </tr>
          </thead>

          <tbody>
            {cluster.systems.map((sys, idx) => {
              const updated = formatNorwegianShort(sys?.updatedAt);
              const old = isOlderThanTwoHours(sys?.updatedAt);
              const batteryVal =
                sys?.batteri ?? sys?.battery ?? sys?.batt ?? null;

              return (
                <tr key={sys?.IMEI ?? idx}>
                  <td className="status-td">
                    <div className="status-icon-wrapper">
                      <StatusIcon status={sys?.status} size={20} />
                    </div>
                  </td>

                  <td className="system-col">
                    <div className="nick">
                      {sys?.nick ?? "—"}
                      <span className="imei">({sys?.IMEI ?? "—"})</span>
                    </div>

                    <div
                      className={`updated ${
                        old ? "updated-old" : "updated-new"
                      }`}
                    >
                      {updated}
                    </div>

                    {sys?.comment ? (
                      <div className="system-comment">{sys.comment}</div>
                    ) : null}
                  </td>

                  <td className="lamper-col">
                    {renderLamperSixLines(sys?.lamper)}
                  </td>

                  <td className="ctrl-col">
                    {(() => {
                      const kb = sys?.kontrollboks;
                      if (kb == null) return <div className="hyphen">-</div>;
                      if (
                        typeof kb === "string" ||
                        typeof kb === "number" ||
                        typeof kb === "boolean"
                      )
                        return <div>{String(kb)}</div>;
                      if (Array.isArray(kb))
                        return kb.length ? (
                          <div className="ctrl-cell">
                            {kb.map((v, i) => (
                              <div key={i}>{renderValueSafeInline(v)}</div>
                            ))}
                          </div>
                        ) : (
                          <div className="hyphen">-</div>
                        );
                      if (typeof kb === "object")
                        return (
                          <div className="ctrl-cell">
                            {Object.entries(kb).map(([k, v]) => (
                              <div key={k}>
                                <strong>{k}:</strong> {renderValueSafeInline(v)}
                              </div>
                            ))}
                          </div>
                        );
                      return <div>{String(kb)}</div>;
                    })()}
                  </td>

                  {showBattery ? (
                    <td className="battery-col">
                      {renderBatteryCompact(batteryVal)}
                    </td>
                  ) : null}
                </tr>
              );
            })}
          </tbody>
        </table>
      ) : (
        <div>Ingen systemer</div>
      )}
    </div>
  );
}
